import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import { ru } from '@/i18n/ru';
import { cn } from '@/lib/cn';

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;

export function DialogContent({
  className,
  children,
  title,
  description,
  ...props
}: ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/70 animate-fade-in" />
      <DialogPrimitive.Content
        className={cn(
          'fixed z-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
          'w-[min(960px,calc(100vw-2rem))] max-h-[min(85vh,900px)]',
          'bg-surface border border-border shadow-none flex flex-col animate-slide-up',
          className,
        )}
        {...props}
      >
        <div className="flex items-center gap-3 border-b border-border px-3 h-10 shrink-0">
          <DialogPrimitive.Title className="text-xs font-semibold tracking-wide uppercase text-text">
            {title}
          </DialogPrimitive.Title>
          {description ? (
            <DialogPrimitive.Description className="text-[11px] text-text-muted truncate">
              {description}
            </DialogPrimitive.Description>
          ) : (
            <DialogPrimitive.Description className="sr-only">{title}</DialogPrimitive.Description>
          )}
          <DialogPrimitive.Close
            className="ml-auto inline-flex h-6 w-6 items-center justify-center text-text-muted hover:text-text hover:bg-row-hover focus-visible:outline focus-visible:outline-1 focus-visible:outline-accent"
            aria-label={ru.close}
          >
            <X className="h-3.5 w-3.5" />
          </DialogPrimitive.Close>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}
